import { Component, ElementRef, Inject } from '@angular/core';
import { AssessmentAnnulTypeEnum, AssessmentQuestionType } from '@app/core/models';
import { Popover, POPOVER_DATA, PopoverRef, Strategy } from '@app/shared/modules/template/components/popover';
import { Store } from '@ngrx/store';
import { PopoverAnnulQuestionComponent } from '../../../modal-evaluation-report/components/popover-annul-question/popover-annul-question.component';
import { ModalAuditActions } from '../../store';
import { ModalAuditState } from '../../store/modal-audit.state';
import { AnswerOptionEnum } from '../../utils/answer-option.enum';
import { AlertService } from '@app/core';
import { take } from 'rxjs';
import { notNull } from '@app/shared';

@Component({
  selector: 'app-popover-answer-options',
  templateUrl: './popover-answer-options.component.html',
})
export class PopoverAnswerOptionsComponent {
  public readonly assessmentQuestionType = AssessmentQuestionType;

  constructor(
    @Inject(POPOVER_DATA) public data: any,
    private _popoverRef: PopoverRef<any>,
    private _popover: Popover,
    private _store: Store<ModalAuditState>,
    private _alertService: AlertService,
  ) {}

  public get isSociodemographic(): boolean {
    return !!this.data.question.sociodemografica;
  }

  public onOpenAnullQuestion(elementRef: ElementRef) {
    this._popover
      .open(PopoverAnnulQuestionComponent, {
        positionStrategy: [Strategy.LEFT],
        elementRef,
        data: {
          ...this.data,
          aplicacao_uuid: this.data.application_uuid,
          tentativa_uuid: this.data.attempt_uuid,
          type: AssessmentAnnulTypeEnum.Answer,
        },
      })
      .closed.subscribe((response) => {
        this._store.dispatch(ModalAuditActions.UpdateAttemptQuestionReducer({ response, data: this.data }));
        this._popoverRef.close();
      });
  }

  public onCleanQuestionAlternative() {
    this._alertService
      .confirm({
        title: 'geral.atencao',
        message: 'gestor-avaliacoes.questao-em-branco',
      })
      .pipe(take(1), notNull())
      .subscribe(() => {
        this._store.dispatch(
          ModalAuditActions.QuestionLoadingReducer({ question_uuid: this.data.question_uuid, loading: true }),
        );
        this._store.dispatch(
          ModalAuditActions.UpdateQuestionScoreEffect({
            ...this.data,
            alternative_uuid: null,
            score: null,
            is_blank: 1,
          }),
        );
        this._popoverRef.close();
      });
  }
}
